import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import useMeta from "@/hooks/useMeta";

const faqs = [
  { q: "What format are ebooks and courses delivered in?",
    a: "Ebooks are delivered as downloadable PDF files. Courses are delivered as streaming video modules paired with downloadable PDF workbooks. Every course includes a completion certificate." },
  { q: "How long do I have access to courses?",
    a: "You have lifetime access to any course you purchase. There is no expiration and no additional monthly fee — pay once, learn at your own pace." },
  { q: "Is there a refund policy?",
    a: "Yes. We offer a 30-day satisfaction guarantee on every product. If a product does not meet your expectations, contact us within 30 days for a full refund." },
  { q: "Do courses have completion certificates?",
    a: "Yes. Every course concludes with an assessment. Upon completion, you can download a personalized certificate suitable for LinkedIn, continuing education records, or company L&D portfolios." },
  { q: "What is the difference between ebooks and courses?",
    a: "Ebooks are self-guided reading materials with practical exercises — ideal for independent study. Courses add structured video instruction from Dr. Campbell, plus workbooks and a completion certificate. Many students use both together." },
  { q: "Do courses need to be taken in a specific order?",
    a: "The Self Leadership series has a natural order (Volumes 1 through 5), but each course is designed to stand alone. Take them in whatever order matches your current needs." },
  { q: "What technical requirements do I need?",
    a: "A modern web browser (Chrome, Safari, Firefox, or Edge) and a stable internet connection for streaming video. PDFs can be viewed on any device that opens PDF files." },
  { q: "How do I access my purchased materials?",
    a: "Immediately after checkout you will receive an email with download links for ebooks and access links for course videos. You can also access all your purchases from your account page anytime." },
];

const FAQs = () => {
  useMeta({
    title: "Frequently Asked Questions — Global Leader Solutions",
    description: "Answers about ebooks, courses, refunds, delivery, technical requirements, and how to access your purchased materials.",
    canonical: "https://globalleadersolutions.com/faqs",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map(f => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });
  return (
  <div data-testid="faqs-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
    <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-3">Support</div>
    <h1 className="text-4xl sm:text-5xl font-serif font-semibold text-[#2D2628] mb-4">Frequently asked</h1>
    <p className="text-base text-[#6B5E62] mb-10 leading-relaxed">
      Everything you need to know about our products, delivery, and access.
    </p>
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#E8DCDD]">
          <AccordionTrigger className="text-left font-serif text-lg text-[#2D2628] py-5 hover:text-[#8C4A57] hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-[#6B5E62] text-sm leading-relaxed pb-5">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
  );
};

export default FAQs;
